import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultOptions = {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
};

export const notify = {
    success: (message, options) => toast.success(message, { ...defaultOptions, ...options }),
    error: (message, options) => toast.error(message, { ...defaultOptions, autoClose: 6000, ...options }),
    warning: (message, options) => toast.warning(message, { ...defaultOptions, ...options }),
    info: (message, options) => toast.info(message, { ...defaultOptions, ...options })
};

export function AppToastContainer({ mode }) {
    return (
        <ToastContainer
            {...defaultOptions}
            newestOnTop
            pauseOnFocusLoss={false}
            limit={4}
            theme={mode === 'dark' ? 'dark' : 'light'}
        />
    );
}

export default notify;
